import { getStyle } from './get-style';

//We have to do this resolving for 'window' because 'window' is not defined on node (for server side render)
/* istanbul ignore next */
const WINDOW = typeof window === 'undefined' ? global : window;
const TAG = /body|html/i;

const overflow = (node) =>
  '' + getStyle(node, 'overflow') + getStyle(node, 'overflow-y') + getStyle(node, 'overflow-x');

const hasScroll = RegExp.prototype.test.bind(/(auto|scroll)/);
const scrolls = (node) => hasScroll(overflow(node));

const parents = (node, acc = []) =>
  !node || node.parentNode === null ? acc : parents(node.parentNode, [...acc, node]);

function scrollParent(node) {
  if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
    return;
  }

  return parents(node.parentNode).find((p) => scrolls(p)) || document.scrollingElement || document.documentElement;
}

const shouldBeWindow = (el) => !el || (TAG.test(el.tagName) && el.clientHeight <= el.scrollHeight);

/**
 * getScrollParent returns the nearest scrolling element (or window) to
 * the element given in the first argument.
 *
 * @method getScrollParent
 * @param  {Element} el DOM Node to query.
 * @return {ScrollingElement} The scrolling element for the given dom node.
 */
export const getScrollParent = (el) => ((x) => (shouldBeWindow(x) ? WINDOW : x))(scrollParent(el));
